// ### shame.js
//
// This file is for hacky, unavoidable functionality. This file is
// loaded globally so try to keep it clean, please.
jQuery(function ($) {

  // Change Recommended Program page's table heading to 'Monthly Cost'
  if ($('body').hasClass('page-id-854')) {
    $('table thead th:last-child').text('Monthly cost');
  }

});